/**
 * @description 更薪用户信息 action
 */
import * as service from '../../services/'
import config from '../../config/'
import {removeStorageInfo, setStorageCache} from '../../utils/'
import {Base64} from 'js-base64'

export default {
  collectUserAction({rootState}, {voucherValue="", actionNo} ={}) {
    const {client} = rootState
    return new Promise((resolve, reject) => {
      service.collectUserAction({
        actionNo,
        authToken: client.user.token
        , userId: client.user.userID
        , voucherValue
        , clientId: client.client.clientVersionId
      }).then(res => {
        let {data} = res
        if (data.success) {
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(e => reject(e))
    })
  }
  // 领取优惠券奖品
  , receiveUserPrize({rootState}, {orderId}) {
    const {client} = rootState
    return new Promise((resolve, reject) => {
      service.receiveUserPrize({
        authToken: client.user.token
        , userId: client.user.userID
        , orderId
        , clientId: client.client.clientVersionId
      }).then(res => {
        let {data} = res
        if (data.success) {
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(e => reject(e))
    })
  }
  // 获取邀请码
  , queryCode({rootState}) {
    const {client} = rootState
    return new Promise((resolve, reject) => {
      service.queryCode({
        authToken: client.user.token
      }).then(res => {
        let {data} = res
        if (data.success) {
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(e => reject(e))
    })
  }
  , getUserInfo({dispatch, rootState}) {
    const {client} = rootState
    return new Promise((resolve, reject) => {
      service.getUserInfo({
        authToken: client.user.token
      })
        .then(res => {
          let {data} = res
          let {success} = data
          if (success) {
            let {valueObject} = data
            let {authToken, fuser} = valueObject
            dispatch('updateUserInfo', {data: {token: authToken, userID: fuser.fOperUserId}})
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch(e => reject(e))
    })
  }
  // 跳转公众号认证
  , authentication() {
    if (config.wxUrl) {
      setStorageCache('reloadAuthken', 'true')
      window.location.href = config.wxUrl
    }
  }
  , getAuthTokenByTicket({dispatch}, {code, unionId, authTokenTicket, wxInfo}) {
    // authTokenTicket 30秒有效
    removeStorageInfo('reloadAuthken')
    if (authTokenTicket) {
      return new Promise((resolve, reject) => {
        service.getAuthTokenByTicket({
          code,
          unionId,
          authTokenTicket
        }).then(res => {
          let {data} = res
          let {code} = data
          if (code === '0000') {
            dispatch('updateUserInfo', {data: {token: data.data.authToken}})
            dispatch('getUserInfo').then(resolve, reject)
          } else {
            if (wxInfo && wxInfo.authTokenTicket !== authTokenTicket) {
              dispatch('authentication')
            }
          }
        }).catch(e => reject(e))
      })
    }
  }
  // 微信小程序登录过期
  , wxMiniOverdue() {
    try {
      /* eslint-disable no-undef */
      wx.miniProgram.postMessage({
        data: JSON.stringify({
          overdue: true
        })
      })
      /* eslint-disable no-undef */
      wx.miniProgram.navigateBack({
        delta: 1
      })
    } catch (e) {
      return ''
    }
  }
  // 跳转去绑定银行卡
  , goBindBackCard({rootState}) {
    try {
      const {client, product} = rootState
      const uuid = window.localStorage.getItem('uuid')
      let _url = ''
      if (product.paymentSubCode === 'ABC_WALLET' || product.paymentSubCode === 'FZS_WALLET_ABC') {
        _url = config.goBindABCWalletUrl
      } else if (product.paymentSubCode === 'CITIC_WALLET_PAY' || product.paymentSubCode === 'FZS_WALLET_CITIC') {
        _url = config.goBindCiticWalletUrl
      } else if (product.paymentSubCode === 'SPDB_WALLET_PAY' || product.paymentSubCode === 'FZS_WALLET_SPDB') {
        _url = config.goBindSPDBWalletUrl
      } else {
        _url = config.goBindBackCardUrl
      }
      _url = `${_url}?t=${Base64.encodeURI(client.user.token)}&channelId=${Base64.encodeURI(client.client.channelId)}&userId=${Base64.encodeURI(client.user.userID)}&clientId=${Base64.encodeURI(client.client.clientVersionId)}&guid=${Base64.encodeURI(uuid)}&from=pay&backIndexUrl=${Base64.encodeURI(window.location.href)}`
      top.window.location = _url
    } catch(e){
      console.log(e)
    }
  }
  // 新钱包支付
  , goFzsWalletPay({rootState}, {payStr, bankName, bankNo, mobile}) {
    try {
      const {client} = rootState
      const path = window.location.origin + window.location.pathname
      const _url = `${payStr}&authToken=${Base64.encodeURI(client.user.token)}&failUrl= ${Base64.encodeURI(path + '#/detail')}&successUrl=${Base64.encodeURI(path + '#/result?state=success')}&bankName=${Base64.encodeURI(bankName)}&bankNo=${Base64.encodeURI(bankNo)}&mobile=${Base64.encodeURI(mobile)}`
      top.window.location = _url
    } catch(e){
      console.log(e)
    }
  }
  // 获取银行卡钱包
  , getBankCard({rootState}) {
    const {client} = rootState
    return new Promise((resolve, reject) => {
      service.getBankCard({
        authToken: client.user.token
      }).then(({ data }) => {
        resolve(data)
      }).catch(e => reject(e))
    })
  }
  , sendCbcPaySmsCode({rootState}) {
    const {client, product} = rootState
    return new Promise((resolve, reject) => {
      service.sendCbcPaySmsCode({
        authToken: client.user.token,
        clientId: client.client.clientVersionId,
        entityTypeId: product.skuDetail.entityTypeId,
        paymentSubMethodId: product.paymentSubCode,
        payType: client.client.env === 'app' ? 'APP' : 'H5',
      }).then(({data}) => {
        resolve(data)
      }).catch(e => reject(e))
    })
  }
  , // 刷新tokne
  getSycnUserInfo({dispatch}, {authToken}){
    return new Promise((resolve, reject) => {
      service.getSycnUserInfo({
        authToken 
      }).then(({data}) => {
        if(data.success){
          const vUserInfo = JSON.parse(data.valueObject.userInfo)
          const userInfo = {token: data.valueObject.authToken, userID: vUserInfo.user.fOperUserId, phoneNum: vUserInfo.user.mobile}
          setStorageCache('cacheUser', userInfo)
          dispatch('updateUserInfo', { data: userInfo })
          resolve(data)
        } else {
          dispatch('updateUserInfo', { data: {token: ''} })
          reject(data)
        }
      }).catch(e => {
        dispatch('updateUserInfo', { data: {token: ''} })
        reject(e)
      })
    })
  }
}
